import { SideWidths } from '@cutr/constants/windows/windows-geometry.ts';

export const FRAME_WIDTH_MM = 79;

export const DEFAULT_FRAME_BEAM_WIDTHS: SideWidths = {
  top: FRAME_WIDTH_MM,
  right: FRAME_WIDTH_MM,
  bottom: FRAME_WIDTH_MM,
  left: FRAME_WIDTH_MM,
};

export const SASH_MARGIN_MM = 10;
export const MULLION_WIDTH_MM = 89; // also valid: 106, 130
export const FLOATING_MULLION_WIDTH_MM = 130; // also valid: 118
export const TRANSOM_WIDTH_MM = 89; // also valid: 79, 106

export const MIN_SASH_WIDTH_MM = 385;
export const MIN_SASH_HEIGHT_MM = 385;
